import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import { showLoader} from "../../../components/loader/loader";

// actions
import {
    setForm,
    setApp,
    ADD_STATE,
    REMOVE_STATE,
    setUdn, setMapConfig
} from "../../../redux/actions/generics/IndexedActions";
import {udnService} from "../../../jwt/_services";
import UdnView from "./_view";



function UdnApp(props) {
    const path = props.path || 'core/udn';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn !== null) {
            udnService.getItem(_udn.id, props.app?.fbDataBase?.id)
                .then(response => {
                    props.setUdn(path, response);
                })
                .catch(e => {
                    console.log(e)
                    props.setUdn(path, _udn);
                })
        }
    },[]);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    { componentState && <UdnView path={path} generalPropouse={false}/> }
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setForm,
    setApp,
    setMapConfig,
});

export default connect(mapStateToProps, mapActionsToProps)(UdnApp)

